import { Drawer } from 'antd'

import { drawerAndModalWidth } from '../../../../../util/guideline'
import { IssuerComplianceRule } from '../models'
import { UpdateIssuerCompliance } from './UpdateIssuerComplianceRule'

interface UpdateIssuerComplianceDrawerProps {
  domain: string
  groupId: number
  issuerComplianceRule: IssuerComplianceRule
  isVisible: boolean
  onClose: () => void
  onSuccess: () => void
}

export const UpdateIssuerComplianceRuleDrawer = ({
  domain,
  groupId,
  issuerComplianceRule,
  isVisible,
  onClose,
  onSuccess,
}: UpdateIssuerComplianceDrawerProps) => {
  return (
    <Drawer
      title="Update Issuer Compliance Rule"
      placement="right"
      open={isVisible}
      onClose={onClose}
      width={drawerAndModalWidth}
      destroyOnClose
    >
      <UpdateIssuerCompliance
        domain={domain}
        groupId={groupId}
        issuerComplianceRule={issuerComplianceRule}
        onSuccess={onSuccess}
      />
    </Drawer>
  )
}
